import * as React from "react";
import { Check } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
const coupons = [{
  discount: "FREE",
  title: "EXPLORER",
  description: "Begin your journey into the world's soil profiles.",
  features: "Basic excavation tools, Global soil database access, Standard identification kit, Community forum access"
}, {
  discount: "€4.99",
  title: "EXPLORER PASS",
  description: "Advanced tools for the serious soil scientist.",
  features: "High-relief scanning tech, Rare mineral detection, Priority data processing, Exclusive field reports"
}, {
  discount: "€19.00",
  title: "CARD PACKS",
  description: "Expand your collection with rare geological finds.",
  features: "5 Rare soil profiles, Guaranteed holographic card, Bonus excavation energy, Limited edition badge"
}, {
  discount: "CUSTOM",
  title: "SCHOOL LICENSE",
  description: "Full institutional access for research teams.",
  features: "Unlimited student profiles, Advanced analytics suite, Custom research modules, Direct ISRIC data sync"
}];
export default function Pricing() {
  return <section data-section-id="223007" id="schools" className="bg-background text-foreground py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-16 text-center">
          <h2 className="font-default text-primary text-3xl font-bold md:text-4xl tracking-wider uppercase">
            Start free. Go deeper for €4.99.
          </h2>
          <p className="font-sans text-muted-foreground mt-4 text-lg">
            Select your clearance level and start excavating the world's hidden layers.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {coupons.map((coupon, i) => {
          const isHighlighted = coupon.title === "EXPLORER PASS";
          const isSchool = coupon.title === "SCHOOL LICENSE";
          return <Card key={i} data-index={i} id={isSchool ? "schools" : undefined} className={`relative bg-white/5 backdrop-blur-xl transition-all duration-300 hover:-translate-y-1 rounded-sm ${isHighlighted ? "border-[#C48A3A] shadow-[0_0_30px_rgba(196,138,58,0.2)] bg-[#7C5CBF]/10" : "border-lavender/20 shadow-md hover:shadow-[0_0_20px_rgba(124,92,191,0.3)]"}`}>
                {isHighlighted && <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10">
                    <Badge className="bg-[#C48A3A] text-[#09080A] font-bold border-none px-4 py-1 uppercase tracking-tighter">
                      Most Popular
                    </Badge>
                  </div>}
                <CardHeader className="text-center pb-4">
                  <div className={`font-default mb-2 text-4xl font-bold tracking-tight bg-gradient-to-br bg-clip-text text-transparent ${isHighlighted ? "from-[#C48A3A] to-[#C9B8F5]" : "from-primary to-secondary"}`}>
                    {coupon.discount}
                  </div>
                  <CardTitle className={`font-default text-xl font-bold uppercase tracking-wide ${isHighlighted ? "text-[#C48A3A]" : "text-foreground"}`}>
                    {coupon.title}
                  </CardTitle>
                  <CardDescription className="font-sans text-muted-foreground mt-2">
                    {coupon.description}
                  </CardDescription>
                </CardHeader>
                <CardContent className="pb-8">
                  <ul className="space-y-3">
                    {coupon.features.split(", ").map((feature, j) => <li key={j} data-index={j} className="flex items-start gap-3">
                        <Check className={`${isHighlighted ? "text-[#C48A3A]" : "text-primary"} mt-0.5 size-5 shrink-0`} />
                        <span className="font-sans text-off-white/90 text-sm">{feature}</span>
                      </li>)}
                  </ul>
                </CardContent>
                <CardFooter className={`border-t-2 border-dashed pt-6 ${isHighlighted ? "border-[#C48A3A]/40" : "border-primary/20"}`}>
                  
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}